import {Component, OnInit} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormGroup} from '@angular/forms';
import {BookingPriceService} from '../../../../services/booking-price.service';
import {BookingPrice} from '../../../../classes/BookingPrice';
import {ConfirmDialogComponent} from '../../../dialog/confirm-dialog/confirm-dialog.component';
import {BookingPriceEditComponent} from '../booking-price-edit/booking-price-edit.component';
import {RoomService} from '../../../../services/room.service';
import {OfficeService} from '../../../../services/office.service';
import {Room} from '../../../../classes/Room';
import {Office} from '../../../../classes/Office';

@Component({
  selector: 'app-booking-price-list',
  styleUrls: ['./booking-price-list.component.scss'],
  templateUrl: './booking-price-list.component.html',
})
export class BookingPriceListComponent implements OnInit {

  public bookingPrices: BookingPrice[];
  public errorMessage: string;
  private currentDialog = null;
  private rooms: Map<number, Room>;
  private offices: Map<number, Office>;

  constructor(private bookingPricesService: BookingPriceService,
              private modalService: NgbModal,
              private roomService: RoomService,
              private officeService: OfficeService) {}

  ngOnInit(): void {
    this.updateList();

    this.roomService.getAll()
      .subscribe(response => this.rooms = new Map(response.map(room => [room.id, room])));

    this.officeService.getAll()
      .subscribe(response => this.offices = new Map(response.map(office => [office.id, office])));
  }

  updateList(): void {
    this.bookingPricesService.getAll().subscribe({
      next: (bookingPrices) => {
        this.bookingPrices = bookingPrices;
      },
      error: (error) => this.errorMessage = error.error.error
    });
  }

  openEditModal(bookingPrice: BookingPrice): void {
    this.currentDialog = this.modalService.open(BookingPriceEditComponent,
      {
        scrollable: true,
        windowClass: 'modal-booking-prices-edit',
        size: 'lg',
        centered: true,
      });

    if (bookingPrice) {
      bookingPrice.timePeriodId = bookingPrice.timePeriod.id;
    }
    this.currentDialog.componentInstance.bookingPrice = bookingPrice;

    this.currentDialog.result.then(
      (result) => {
        if (result instanceof FormGroup) {
          const editedBookingPrice = new BookingPrice(result.value);

          this.bookingPricesService.addOrEdit(editedBookingPrice).subscribe({
            next: () => this.updateList(),
            error: (error) => this.errorMessage = error.error.error
          });
        }
      },
      (error) => { console.log('Dialog close error: ' + error); }
    );
  }

  openDeleteConfirmModal(bookingPrice: BookingPrice): void {
    this.currentDialog = this.modalService.open(ConfirmDialogComponent,
      {
        scrollable: true,
        windowClass: 'modal-booking-price-delete-confirm',
        size: 'md',
        centered: true,
        // keyboard: false,
        // backdrop: 'static'
      });

    this.currentDialog.componentInstance.message =
      'Are you sure that you want to booking price with id ' + bookingPrice.id + '?';

    this.currentDialog.result.then((result) => {
      if (result.status === 'confirmed') {
        this.bookingPricesService.delete(bookingPrice.id).subscribe({
          next: () => this.updateList(),
          error: (error) => this.errorMessage = error.error.error
        });
      }
    }, (error) => {
      console.log('Dialog close error: ' + error);
    });
  }

  getOffice(officeId: number): string {
    const office = this.offices.get(officeId);
    return office.city + ', ' + office.address;
  }

  getRoom(roomId: number): string {
    return this.rooms.get(roomId).name;
  }
}

